import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-gray-700 p-4 text-center text-gray-300">
            <div className="container mx-auto">
                <p>&copy; 2025/26 BurgerShot - EqualityRP. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;